import ConnectionList from "../ConnectionList";
import { useLazyGetFollowingQuery } from "features/community/apis";

const Following = () => {
  const [trigger, { isFetching }] = useLazyGetFollowingQuery();
  return (
    <ConnectionList title="Following" trigger={trigger} isFetching={isFetching} listType="following" />
  );
};

export default Following;
